export const FINDER_FILTER_COUNT_ATTRIBUTE = "data-applied-count";
